import { onMounted, reactive, ref } from "@vue/composition-api"

export const getAreas = (ctx, show_log) => {
  const data = reactive({ areas: [] })
  onMounted(async () => {
    let nd = await ctx.root.$lazy("NationalData")
    data.areas = nd.areas
    // if (show_log) {

    // }
  })
  return data
}
